import React from 'react';
import PropTypes from 'prop-types';
import TrailmixElement from 'components/trailmixes/TrailmixElement';
import CustomStepEdit from 'components/trailmixes/CustomSteps/CustomStepEdit';

function customStepForm(props) {
  return <CustomStepEdit {...props} />;
}

function trailmixStepForm(props) {
  return (
    <div className="trailmix-custom-step-item">
      <TrailmixElement {...props} />
    </div>
  );
}

export default function CustomStepItem(props) {
  return props.isInEditMode ? customStepForm(props) : trailmixStepForm(props);
}

CustomStepItem.propTypes = {
  isInEditMode: PropTypes.bool
};
